<app-toolbar></app-toolbar>
<div class="content">
  <app-home-page></app-home-page>
</div>
<app-footer></app-footer>
